import * as React from "react";
import GeneralWelcomeMetrics from "components/welcome/GeneralWelcomeMetrics";
import SecurityWelcomeMetrics from "./SecurityWelcomeMetrics";
const securityWelcomeMetrics = [
  {
    label: "Security",
    component: SecurityWelcomeMetrics,
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const generalWelcomePageMetrics = [
  {
    component: () => /* @__PURE__ */ React.createElement(GeneralWelcomeMetrics, { topSourcesOnly: true }),
    isEnabled: ({ isValidSecurityLicense }) => isValidSecurityLicense
  }
];
const pluginExports = {
  welcomePageMetrics: securityWelcomeMetrics,
  "welcomePageMetrics.general": generalWelcomePageMetrics
};
export default pluginExports;
